import { createMap, forMember, mapFrom, constructUsing } from "@automapper/core";
import { PlayerBonus } from "../../contract/pam.js";
import { BonusCodeDetailsViewModel } from "../bonus-code/types.js";
import "../../api/types.js";
import "immer";
import { formatTimestamp } from "../../utils/date.js";
import "react-intl";
import "@apollo/client/errors";
import "rxjs";
import "rxjs/operators";
import "@apollo/client";
import "graphql";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react";
import "react-error-boundary";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import "../../auto-mapper/AutoMapperProvider.js";
import "typesafe-actions";
import "redux-observable";
import "../../redux-folder/async-action/action.js";
import "../../redux-folder/error-handling/action.js";
import "../../redux-folder/actions.js";
import "fast-deep-equal/es6";
import "redux";
import "../../redux-folder/entity/epics.js";
import "normalizr";
import "../../redux-folder/entity/EntityProvider.js";
import "../../redux-folder/realtime/RealtimeNotification.js";
import "reselect";
import "react-redux";
import "react-router";
import { BonusCodeDetailsViewModelKeysTypeName } from "../bonus-code/constants.js";
import { PlayerBonusViewModel } from "./types.js";
import { PlayerBonusViewModelKeysTypeName, PlayerBonusQueryFieldsTypeName, PlayerBonusColumnTypeName } from "./constants.js";
import "./components/DataGrid.js";
class PlayerBonusMapping {
  createMapping(mapper) {
    createMap(
      mapper,
      PlayerBonus,
      PlayerBonusViewModel,
      forMember(
        (vm) => vm.id,
        mapFrom((m) => m.bonus_id)
      ),
      forMember(
        (vm) => vm.bonus_engine_code,
        mapFrom((m) => m.bonus_engine_code)
      ),
      forMember(
        (vm) => vm.bonus_id,
        mapFrom((m) => m.bonus_id)
      ),
      forMember(
        (vm) => vm.bonus_name,
        mapFrom((m) => m.bonus_name)
      ),
      forMember(
        (vm) => vm.bonus_status,
        mapFrom((m) => m.bonus_status)
      ),
      forMember(
        (vm) => vm.created_at,
        mapFrom((m) => formatTimestamp(m.created_at, "date-time"))
      ),
      forMember(
        (vm) => vm.desc,
        mapFrom((m) => m.desc)
      ),
      forMember(
        (vm) => vm.expire_at,
        mapFrom((m) => formatTimestamp(m.expire_at, "date"))
      ),
      forMember(
        (vm) => vm.marketing_code,
        mapFrom((m) => m.marketing_code)
      ),
      forMember(
        (vm) => vm.realized_amount,
        mapFrom((m) => m.realized_amount)
      ),
      forMember(
        (vm) => vm.total_amount,
        mapFrom((m) => m.total_amount)
      ),
      forMember(
        (vm) => vm.type,
        mapFrom((m) => m.type)
      ),
      forMember(
        (vm) => vm.uid,
        mapFrom((m) => m.uid)
      ),
      forMember(
        (vm) => vm.remaining_amount,
        mapFrom((m) => m?.total_amount && m?.realized_amount ? m.total_amount - m.realized_amount : null)
      )
    );
    createMap(
      mapper,
      BonusCodeDetailsViewModel,
      PlayerBonusViewModel,
      forMember(
        (vm) => vm.release_mechanism,
        mapFrom((m) => m?.release_mechanism)
      ),
      forMember(
        (vm) => vm.credit_type,
        mapFrom((m) => m?.credit_type)
      )
    );
    createMap(
      mapper,
      PlayerBonusViewModelKeysTypeName,
      PlayerBonusQueryFieldsTypeName,
      constructUsing((m, _) => {
        const mapper2 = {
          id: ["bonus_id"],
          bonus_engine_code: ["bonus_engine_code"],
          bonus_id: ["bonus_id"],
          bonus_name: ["bonus_name"],
          bonus_status: ["bonus_status"],
          "created_at.seconds": ["created_at.seconds"],
          desc: ["desc"],
          "expire_at.seconds": ["expire_at.seconds"],
          marketing_code: ["marketing_code"],
          realized_amount: ["realized_amount"],
          total_amount: ["total_amount"],
          type: ["type"],
          uid: ["uid"],
          remaining_amount: ["total_amount", "realized_amount"],
          release_mechanism: [],
          credit_type: []
        };
        return [...new Set(m.flatMap((i) => mapper2[i]))];
      })
    );
    createMap(
      mapper,
      `${PlayerBonusColumnTypeName}[]`,
      `${PlayerBonusViewModelKeysTypeName}[]`,
      constructUsing((m, _) => {
        const mapper2 = {
          bonus_name: ["bonus_name"],
          bonus_status: ["bonus_status"],
          "created_at.seconds": ["created_at.seconds"],
          desc: ["desc"],
          "expire_at.seconds": ["expire_at.seconds"],
          marketing_code: ["marketing_code"],
          realized_amount: ["realized_amount"],
          total_amount: ["total_amount"],
          remaining_amount: ["remaining_amount"],
          expireButton: []
        };
        return [...new Set(m.flatMap((i) => mapper2[i]))];
      })
    );
    createMap(
      mapper,
      `${PlayerBonusColumnTypeName}[]`,
      `${BonusCodeDetailsViewModelKeysTypeName}[]`,
      constructUsing((m, _) => {
        const mapper2 = {
          bonus_name: [],
          bonus_status: [],
          "created_at.seconds": [],
          desc: [],
          "expire_at.seconds": [],
          marketing_code: [],
          realized_amount: [],
          total_amount: [],
          remaining_amount: [],
          expireButton: ["release_mechanism", "credit_type"]
        };
        return [...new Set(m.flatMap((i) => mapper2[i]))];
      })
    );
  }
}
export {
  PlayerBonusMapping
};
//# sourceMappingURL=mapper.js.map
